class QuizComponent extends HTMLElement {
  constructor() {
    super();
    this.step = 1;
    this.result = this.querySelector('.quiz_result_weight strong');
    this.resultTitle = this.querySelector('[data-result-title]');
    this.topWrapper = this.querySelector('.quiz_top');
    this.topSteps = this.querySelector('.quiz_top_steps');
    this.stepEl = this.topSteps.querySelector('span');
    this.image = this.querySelector('.quiz_result_image');
    this.nextBtns = this.querySelectorAll('.next-container');
    this.inputText = this.querySelector('#quiz-name');
    this.totalSteps = this.querySelectorAll('[data-step]').length;
    this.stepName = this.querySelector('[data-name]:not([hidden])').dataset.name;
    this.welcome = this.querySelector('[data-name="welcome"]');
    this.nameInput = this.querySelector('.quiz_name-wrapper input[name="name"]');
    // this.emailInput = this.querySelector('.quiz_name-wrapper input[name="email"]');
    this.next = this.querySelector('.quiz_next');
    this.back = this.querySelector('.quiz_back');
    this.variantSelect = this.querySelector('input[type="radio"]');
    this.names = {};
    this.product = {};
    this.resultData = {};

    this.addEventListener('change', this.handleInput.bind(this));

    this.nextBtns.forEach(function (btn) {
      btn.addEventListener('click', this.nextStep.bind(this));
    }.bind(this));

    this.welcome.addEventListener('click', this.nextStep.bind(this));

    this.nameInput.addEventListener('keypress', function (e) {
      let target = e.target;
      if (target.nextElementSibling) return;
      if (e.key === 'Enter') this.nextStep();
      let btn = target.closest('div').nextElementSibling;
      btn.removeAttribute('disabled');
    }.bind(this));


    this.next.addEventListener('click', this.nextQuestion.bind(this));

    document.addEventListener("keyup", function (event) {
      if (event.keyCode === 13 && document.querySelector('.quiz_question[data-step="1"]').dataset.completed != "false") {
        let elem = document.querySelector('.quiz_next');
        let style = getComputedStyle(elem);
        if (style.display != 'none') document.querySelector('.quiz_next').click();
      }
    });

    this.back.addEventListener('click', this.backQuestion.bind(this));

    if (location.search.includes('continue=true')) this.updateStep(); else if (location.search.includes('step')) this.updateURL();
    return this;
  }

  handleInput(e) {
    let name = e.target.name,
      value = e.target.value;
    theme.quiz.data[name] = value;

   if (name === 'name') {
      this.inputText.innerHTML = value;
      let _btn = e.target.closest('div').nextElementSibling;
      return;
    }

    switch (name) {
      case 'weight':
        this.names.weight = parseInt(value);
        break;

      default:
        this.names[name] = value;
        break;
    }

    let selectStep = this.querySelector('[data-step="' + this.step + '"]');

    selectStep.dataset.completed = 'true';
  }

  nextStep() {
    let div = this.querySelector('.quiz_content:not([hidden])');
    let nextDiv = div.nextElementSibling;
    div.setAttribute('hidden', '');
    nextDiv.removeAttribute('hidden');
    if (div.nextElementSibling.hasAttribute('data-step')) this.topWrapper.removeAttribute('hidden');
    this.updateURL();
    setTimeout(function () {
      nextDiv.classList.add('quiz-transition');
    }, 100);
  }

  nextQuestion(e) {
    if (this.step == 1 || this.step == 2 ) {
      this.querySelector('[data-step="' + this.step + '"]').setAttribute('hidden', '');
      this.step = this.step + 1;
      if (this.step < this.totalSteps) this.stepEl.innerHTML = '0' + this.step; else {
        this.getResults();
        this.topWrapper.setAttribute('hidden', '');
      }
      if (this.querySelector('[data-step="' + this.step + '"]')) {
        this.querySelector('[data-step="' + this.step + '"]').removeAttribute('hidden');
      }
      let nextStep = this.querySelector('[data-step="' + this.step + '"]');
      this.updateURL();
      setTimeout(function () {
        nextStep.classList.add('quiz-transition');
      }, 100);
    }

  }

  backQuestion() {
    if (this.step === 1) return;
    this.querySelector('[data-step="' + this.step + '"]').setAttribute('hidden', '');
    this.step = this.step - 1;
    this.stepEl.innerHTML = '0' + this.step;
    this.querySelector('[data-step="' + this.step + '"]').removeAttribute('hidden');
    let prevStep = this.querySelector('[data-step="' + this.step + '"]');
    this.updateURL();
    setTimeout(function () {
      prevStep.classList.add('quiz-transition');
    }, 100);
  }

  getUrl() {
    let cta = this.querySelector('.quiz_result_link[data-product="' + this.product.keyword + '"]');
    let weight = this.names.weight;

    let href = this.product.url
    let firstVariant;
    let variant = this.product.variants.find(function (variant) {
      if (variant.weight === weight) {
        if (!firstVariant) firstVariant = variant;
        return variant.available;
      }
    });
    if (!variant) variant = firstVariant;
    if (variant?.id) href = "".concat(this.product.url, "?variant=").concat(variant.id);

    cta.href = href
    this.resultData.url = href
  }

  getResults() {
    let res;
    // if (this.names.weight === 10 || this.names.snuggle === 'middle') res = 'Cotton Napper';else if (this.names.snuggle === 'hot') res = 'Tree Napper';else res = 'Velvet Napper';

    // new Condition
    // if url path name contains /de
    if (window.location.pathname.includes('/de')) {
      if (this.names.temperature == 'Hot') {
        res = 'Bio-Baumwolle Gewichtsdecke ';
      if (this.names.weight === 5) this.names.weight = 5;
      } else if (this.names.temperature == 'Average') {
        res = 'Bio-Baumwolle Gewichtsdecke ';
      } else if (this.names.temperature == 'Cold') {
        res = 'Bio-Baumwolle Gewichtsdecke ';
        if (this.names.weight === 7) this.names.weight = 7;
      }
    } else {
    if (this.names.temperature == 'Hot') {
      res = 'Cotton Weighted Blanket';
    if (this.names.weight === 5) this.names.weight = 5;
    } else if (this.names.temperature == 'Average') {
      res = 'Cotton Weighted Blanket';
    } else if (this.names.temperature == 'Cold') {
      res = 'Cotton Weighted Blanket';
      if (this.names.weight === 7) this.names.weight = 7;
    }
  }
    // if (this.names.cover == 'Yes' && this.names.size == 'Queen') {
    //   res = 'Cotton Weighted Blanket';
    //   if (this.names.weight === 10 || this.names.weight === 7) this.names.weight = 9;
    //   else this.names.weight = 9;
    // } else if (this.names.cover == 'Yes' && this.names.size == 'King') {
    //   res = 'Cotton Weighted Blanket';
    //   this.names.weight = 9
    // }
    // new Condition

    if ('name' in theme.quiz.data) this.resultTitle.innerHTML = "Hey ".concat(theme.quiz.data.name, ",<br>").concat(this.resultTitle.innerHTML);
    this.product = theme.quiz[res];

    let weight = this.names.weight;

    let result = weight + ' kg ' + res;
    this.result.innerHTML = result;
    this.getUrl();
    this.image.src = this.product.image;
    this.resultData.image = this.product.small_image;
    document.body.classList.add('result-' + this.product.keyword);
    this.querySelector('.quiz_result_link[data-product="' + this.product.keyword + '"]').removeAttribute('hidden');
    theme.quiz.data['result'] = result;
    this.resultData.title = result;
    sessionStorage.setItem('BearabyQuizResult', JSON.stringify(this.resultData))
    theme.utils.klaviyo('quizCompleted', theme.quiz.data, 'track');
  }

  updateURL() {
    if (this.querySelector('[data-name]:not([hidden])').dataset.name != null) {
      this.stepName = this.querySelector('[data-name]:not([hidden])').dataset.name;
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('step', this.stepName);
      let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
      if (this.stepName === 'welcome') setTimeout(function () {
        if (this.stepName === 'welcome') this.nextStep();
      }.bind(this), 3000);
    }
  }

  updateStep() {
    let remainingParams = [];
    let params = window.location.search.slice(1);
    let paramsArr = params.split('&');
    this.querySelector('[data-name="start"]').setAttribute('hidden', '');
    paramsArr.forEach(function (param) {
      let key = param.split('=')[0];
      let value = decodeURIComponent(param.split('=')[1]);

      if (key.slice(0, 2) === 'q_') {
        let name = key.slice(2);
        theme.quiz.data[name] = value;

        let wrapper = this.querySelector('.quiz_question[data-name="' + name + '"]');

        if (wrapper) {
          wrapper.dataset.completed = 'true';
          wrapper.classList.add('quiz-transition');
          let input = wrapper.querySelector('input[value="' + value + '"]');
          if (input) input.checked = true;
        }
      } else if (key !== 'continue' && value !== '') remainingParams.push(param);
    });
    let paramsString = remainingParams.length > 0 ? '?' + remainingParams.join('&') : '';
    let newRelativePathQuery = window.location.pathname + paramsString;
    history.pushState(null, '', newRelativePathQuery);
    let newStep = this.querySelector('.quiz_question[data-completed="false"]');

    if (newStep && 'step' in newStep.dataset) {
      this.topWrapper.removeAttribute('hidden');
      this.step = parseInt(newStep.dataset.step);
      this.stepEl.innerHTML = '0' + this.step;
      newStep.removeAttribute('hidden');
      setTimeout(function () {
        newStep.classList.add('quiz-transition');
      }, 100);
    } else this.querySelector('[data-name="start"]').removeAttribute('hidden');
  }
}

customElements.define('quiz-component', QuizComponent);
